import api from '../../auth/apiClient';
import { SAKTI_API_CONFIG } from '../apiConfig';
import {
  SaktiFaceEmployeeImagesData,
  SaktiFaceEmployeeListData,
  SaktiFaceBatchListData,
  SaktiFaceStatsData,
  SaktiFaceRegistryFilters,
} from '../types';

interface SaktiResponse<T> {
  success: boolean;
  data: T;
}

export class SaktiFaceRegistryApiService {
  static async getEmployees(
    filters: SaktiFaceRegistryFilters
  ): Promise<SaktiFaceEmployeeListData> {
    const params: Record<string, string | number | boolean> = {
      page: filters.page,
      limit: filters.limit,
    };
    if (filters.search) params.search = filters.search;
    if (filters.estateOdooId) params.estate_odoo_id = filters.estateOdooId;
    if (filters.divisionOdooId) params.division_odoo_id = filters.divisionOdooId;
    if (filters.jobPosition) params.job_position = filters.jobPosition;
    if (filters.enrolledOnly) params.enrolled_only = true;

    const response = await api.get<SaktiResponse<SaktiFaceEmployeeListData>>(
      SAKTI_API_CONFIG.FACE_REGISTRY_EMPLOYEES_PATH,
      { params }
    );
    return response.data.data;
  }

  static async getJobPositions(): Promise<string[]> {
    const response = await api.get<SaktiResponse<string[]>>(
      SAKTI_API_CONFIG.FACE_REGISTRY_JOB_POSITIONS_PATH
    );
    return response.data.data;
  }

  static async getEmployeeImages(employeeId: number): Promise<SaktiFaceEmployeeImagesData> {
    const response = await api.get<SaktiResponse<SaktiFaceEmployeeImagesData>>(
      SAKTI_API_CONFIG.FACE_REGISTRY_EMPLOYEE_IMAGES_PATH(employeeId)
    );
    return response.data.data;
  }

  // Returns a blob URL for use in <img> or <canvas>.
  // Caller must revoke it with URL.revokeObjectURL() on unmount.
  static async getImageBlobUrl(relPath: string): Promise<string> {
    const response = await api.get(SAKTI_API_CONFIG.FACE_REGISTRY_IMAGE_PATH(relPath), {
      responseType: 'blob',
    });
    return URL.createObjectURL(response.data as Blob);
  }

  static async getBatches(): Promise<SaktiFaceBatchListData> {
    const response = await api.get<SaktiResponse<SaktiFaceBatchListData>>(
      SAKTI_API_CONFIG.FACE_REGISTRY_BATCHES_PATH
    );
    return response.data.data;
  }

  static async getStats(): Promise<SaktiFaceStatsData> {
    const response = await api.get<SaktiResponse<SaktiFaceStatsData>>(
      SAKTI_API_CONFIG.FACE_REGISTRY_STATS_PATH
    );
    return response.data.data;
  }
}

export default SaktiFaceRegistryApiService;
